import {
    getUserId
} from './appUtils';
import {
    getAppId
} from './appUtils';
import {
    getLMSDomain
} from './appUtils';

// let url = 'http://api.tt.ttcn.cn',
let url = '',
    studyUrl = '',
    oldStudyUrl = '';
let tsgcPcUrl = '';
if (process.env.NODE_ENV === 'development') {
    url = 'https://api.test.gdteacher.com'; //原有
    // url = 'https://api.test.gdteacher.com'; //现改
    studyUrl = 'http://shxy.cmp.test.gdteacher.com/study/';
    oldStudyUrl = 'http://study.tt.ttcn.cn';
} else if (process.env.NODE_ENV === 'test') {
    url = 'https://api.test.gdteacher.com';
    studyUrl = 'http://shxy.cmp.test.gdteacher.com/study/';
    oldStudyUrl = 'http://study.test.ttcn.cn';
} else if (process.env.NODE_ENV === 'production') {
    url = 'https://api.ttcn.cn';
    studyUrl = 'http://ycourse.ttcn.cn/study/';
    oldStudyUrl = 'http://study.ttcn.cn';
}
export const apis = {
    managerUrl: getLMSDomain(),
    tsgcPcUrl: tsgcPcUrl,
    imageUpload: 'http://file.gzedu.com/apiUpload/upload.do',
    api: {
        common: {
            getMenuConfig: url + '/yjypService/personal/user/config',
        },
        demo: {
            getDiscovery: url + '/bizService/app/module/getDiscovery',
        },
        login: {
            teacherQuickLogin: url + '/oauthService/quickLoginOther',
            token: url + '/oauthService/teacher/login',
            getNoticeList: url + '/yjypService/article/getArticleByCategoryIds/',
            getProficalTeam: url + '/yjypService/article/getArticleByCategoryIds/57',
            getCategoryId: url + '/yjypService/category/search',
            getNoticedetails: url + '/yjypService/article/',
            getMsgCode: url + '/captcha',
            modifyPassword: url + '/baseData/user/user/v2/modifyPassword',
            modifyPasswordWithSmsCode: url + '/baseData/user/user/v2/modifyPasswordWithSmsCode',
            changePassword: url + '/baseData/user/user/changePwdMd5',
            changePassword1: url + '/baseData/user/user/changePwd',
            unfreezeUser: url + '/baseData/email/unfreeze-user',
            verifyEmail: url + '/baseData/email/verify-email',
            sendEmailCode: url + '/baseData/email/send-email',
            checkEmailExist: url + '/baseData/email/check-email-exist',
            verifyEmailModifyPassword: url + '/baseData/email/verify-email-modify-password',
            getCodeImage: url + '/captcha/imageUrl', //获取图形验证码
            yxLogin: url + '/oauthService/yxjjw/yxLogin',
            sendMsg: url + '/baseData/msg/login/sendMsg', //发送短信验证码
            phoneCheck: url + '/oauthService/phone/check', //手机验证码登录
        },
        home: {
            getTeacherInfo: url + '/baseData/user/teacher/getTeacherInfo/',
            msServer: url + '/oauthService',
            baseServer: url + '/baseData',
            checkToken: url + '/oauthService/checkToken/',
            proServer: url + '/yjypService',
            getNoticedetail: '/noticedetail.html',
            getUserAreaZone: url + '/yjypService/projectUser/getUserAreaZone/', //获取社区列表
            getFullNameByShortCode: url + '/yjypService/projectUser/getTitleName/', // 获取区域社区名
        },
        study: {
            getStudyProjectDetail: url + '/yjypService/project/getXuexiSpaceProjectDetail/',
            getStudyCourseList: url + '/yjypService/term/getXuexiSpaceCourseList/',
            getStudyCourseStatus: url + '/yjypService/term/getXuexiSpaceChooseStatus/',
            goStudyPreview: studyUrl,
            oldGoStudyPreview: oldStudyUrl + '/login/singleLogin.do?formMap.USER_ID=',
            // getSubjectLabel: url + '/baseData/basecode/findCodeByTypeCode',
            getSubjectLabel: url + '/baseData/basecode/findSubjectAndSection?format=1',
            getTeachGradeLabel: url + '/baseData/basecode/findCodeByTypeCode',
            getCourseCenterList: url + '/yjypService/term/getCourseCenterList/',
            getCourseDetail: url + '/yjypService/term/getAndCheck/',
            getCourseUrl: url + '/courseService/course/search?currentPage=1&pageSize=10',
            //getCourseUrl:url+'/courseService/course/search?appId='+'APPY041'+'&currentPage=1&pageSize=10',
            chooseCourse: url + '/yjypService/chooseCourse/choose',
            checkToken: url + '/oauthService/checkToken/',
            proServer: url + '/yjypService',
            getToStudyUrl: url + '/yjypService/out-course/get_learn_url', //获取外部课程地址
            getProjectStages: url + '/yjypService/projectStage/getProjectStages/', //获取项目阶段
        },
        setting: {
            findCodeByTypeCode: url + '/baseData/basecode/findCodeByTypeCode?typeCode=',
            // getTeachGrade: url + '/baseData/basecode/findCodeByTypeCode?typeCode=teach_grade',
            getTeachGrade: url + '/baseData/basecode/findSubjectAndSection?type=1',
            getSubject: url + '/baseData/basecode/findCodeByTypeCode?typeCode=subject',
            getSubjectAgain: url + '/baseData/basecode/subject/getSubjectBySection/',
            // getSubjectAgain: url + '/baseData/basecode/findSubjectAndSection?format=1',
            getEducationLevel: url + '/baseData/basecode/findCodeByTypeCode?typeCode=education_level',
            getCareerTitle: url + '/baseData/basecode/findCodeByTypeCode?typeCode=career_title',
            updatePhoto: url + '/baseData/user/user/updatePhoto/',
            quickUpdateTeacherInfo: url + '/baseData/user/teacher/quickUpdateTeacherInfo',
            imageUpload: 'http://file.gzedu.com/apiUpload/upload.do',
        },
        record: {
            getMyProjectList: url + '/yjypService/project/getMyProjectList/',
            getMyProjectResultList: url + '/yjypService/project/getMyProjectResultList/',
            printCertificate: url + '/yjypService/project-certificate/viewCertificate/',
            searchTrainAssessList: url + '/qmpxService/api/assess/train-batch-stu/stuAssessRecordList'
        },
        schoolLevelManagement: {
            updateSchoolProject: url + '/schoolBasedTrain/train/school-project/updateSchoolProject/',
            getSchoolProject: url + '/schoolBasedTrain/train/school-project/getSchoolProject/',
            saveSchoolProject: url + '/schoolBasedTrain/train/school-project/saveSchoolProject',
            getSchoolType: url + '/schoolBasedTrain/train/school-project-type/page-search',
            getTrainInfo: url + '/schoolBasedTrain/train/school-project/page-search',
            getCourseInfo: url + '/schoolBasedTrain/train/course-info/page-search',
            exportCourseForDeptMgr: url + '/schoolBasedTrain/train/course-info/exportCourseForDeptMgr',
            getCourseDetail: url + '/schoolBasedTrain/train/course-info/',
            saveCourseDetail: url + '/schoolBasedTrain/train/course-info',
            upDateCourseDetail: url + '/schoolBasedTrain/train/course-info/',
            upLoadCourseFile: url + '/schoolBasedTrain/train/course-file',
            deleteFileByCourseId: url + '/schoolBasedTrain/train/course-file/deleteFileByCourseId/',
            getListByCourseId: url + '/schoolBasedTrain/train/file-style/getListByCourseId/',
            addFileStyle: url + '/schoolBasedTrain/train/file-style',
            // getListByCourseId: url + '/schoolBasedTrain/train/file-style/getListByCourseId/',
            deleteFileStyle: url + '/schoolBasedTrain/train/file-style/deleteById/',
            getGradesList: url + '/schoolBasedTrain/train/course-info/coursePageSearch',
            registerScore: url + '/schoolBasedTrain/train/choose-course/registerScore',
            getFindGradesList: url + '/schoolBasedTrain/train/choose-course/page-search',
            getViewGradeList: url + '/schoolBasedTrain/train/choose-course/page-search',
            getFundsListByYear: url + '/schoolBasedTrain/train/funds/getFundsListByYear/',
            exportFundsListByYear: url + '/schoolBasedTrain/train/funds/exportFundsDetail/',
            coursePageSearchExport: url + '/schoolBasedTrain/train/course-info/coursePageSearchExport',
            saveFundsList: url + '/schoolBasedTrain/train/funds/saveFundsList',
            getFundsDetail: url + '/schoolBasedTrain/train/funds-detail/page-search',
            addFundsDetail: url + '/schoolBasedTrain/train/funds-detail',
            editFundsDetail: url + '/schoolBasedTrain/train/funds-detail',
            delFundsDetail: url + '/schoolBasedTrain/train/funds-detail',
            deleteStyleFile: url + '/schoolBasedTrain/train/course-file/',
            getQueryStatistics: url + '/schoolBasedTrain/train/course-info/coursePageSearch',
        },
        schoolBasedTraining: {
            getCourseList: url + '/schoolBasedTrain/train/choose-course/getCourseList',
            getProjectListListgetCourseList: url + '/projectApply/train/choose-project/getProjectList',
            queryCanMatchTeachList: url + '/projectApply/project/queryCanMatchTeachList',
            enroll: url + '/schoolBasedTrain/train/choose-course/chooseCourseForUser',
            chooseProjectForUser: url + '/projectApply/train/choose-project/chooseProjectForUser',
            getMyEnrollmentRecords: url + '/schoolBasedTrain/train/choose-course/page-search',
            getProjectApplyMyEnrollmentRecords: url + '/projectApply/train/choose-project/page-search',
            cancelChooseCourse: url + '/schoolBasedTrain/train/choose-course/cancelChooseCourse',
            cancelChooseProject: url + '/projectApply/train/choose-project/cancelChooseProject',
            getSelectProjectByUserId: url + '/projectApply/apply/select-project/getSelectProjectByUserId/',
            getSelectProjectByUserIdAndDeptCode: url + '/projectApply/apply/select-project/getSelectProjectByUserIdAndDeptCode/',
            getMySelectProject: url + '/projectApply/apply/select-project/getMySelectProject/',
            getMySelectProjectv2: url + '/projectApply/apply/select-project/v2/getMySelectProject/',
        },
        train: {
            getMyTrainProjectList: url + '/yjypService/project/getMyTrainProjectList/',
            getMyTrainProjectListSimple: url + '/yjypService/project/getMyTrainProjectListSimple/',
            updateTeacher: url + '/yjypService/projectUser/updateTeacher',
            baseDataTeacher: url + '/baseData/user/teacher/page',
            traingetCourseList: url + '/schoolBasedTrain/train/course-info/coursePageSearch',
            projectPageSearch: url + '/projectApply/train/choose-project/projectPageSearch',
            traingetCourseListgetCourseList: url + '/schoolBasedTrain/train/choose-course/getCourseList/',
            traingetCourseListgetProjectList: url + '/projectApply/train/choose-project/getProjectList/',
            schoolBasedTrain: url + '/schoolBasedTrain/train/course-info/page-search',
            coursePageSearch: url + '/schoolBasedTrain/train/course-info/coursePageSearch',
            projectApplyPageSearch: url + '/projectApply/train/choose-project/projectPageSearch',
            getProjectApplyMyEnrollmentRecords: url + '/projectApply/train/choose-project/page-search',
            getTeacherList: url + '/schoolBasedTrain/train/choose-course/getTeacherList/',
            projectApplygetTeacherList: url + '/projectApply/train/choose-project/getTeacherList/',
            chooseUserForCourse: url + '/schoolBasedTrain/train/choose-course/chooseUserForCourse/',
            chooseUserForProject: url + '/projectApply/train/choose-project/chooseUserForProject/',
            cancelChooseCourse: url + '/schoolBasedTrain/train/choose-course/cancelChooseCourse',
            projectApplycancelChooseCourse: url + '/projectApply/train/choose-project/cancelChooseProject',
            cancelChooseProject: url + '/projectApply/train/choose-project/cancelChooseProject',
            chooseCourseForUser: url + '/schoolBasedTrain/train/choose-course/chooseCourseForUser/',
            chooseProjectForUser: url + '/projectApply/train/choose-project/chooseProjectForUser/',
            chooseSearch: url + '/schoolBasedTrain/train/choose-course/page-search/',
            courseSearch: url + '/schoolBasedTrain/train/course-info/page-search',
            courseSearch1: url + '/projectApply/train/choose-project/page-search',
            chooseSearchpage: url + '/schoolBasedTrain/train/choose-course/page-search',
            chooseSearchpage1: url + '/projectApply/train/choose-project/page-search',
            projectenroll: url + '/yjypService/project-user-enroll/do-user-enroll',
            chooseProject: url + '/projectApply/train/choose-project/',
            chooseCourse: url + '/schoolBasedTrain/train/choose-course/',
            projectUserEnroll: url + '/yjypService/project-user-enroll/page-search',
            projectUserEnrollApprove: url + '/yjypService/project-user-enroll/district-approve',
            projectUserEnrollSchoolApprove: url + '/yjypService/project-user-enroll/school-approve',
            projectEnroll: url + '/yjypService/project-user-enroll/apply-project-list',
            courseOrder: url + '/schoolBasedTrain/train/course-order/page-search',
            chooseCreateOrder: url + '/schoolBasedTrain/train/choose-course/createOrder/',
            projectEnrollDetail: url + '/yjypService/project-user-enroll//enroll-detail',
            getToDoCount: url + '/yjypService/school-admin-todo/todo-count/',
            projectEnrollDistrict: url + '/yjypService/project-user-enroll/district-approve',
            enrollpagesearch: url + '/yjypService/project-user-enroll/page-search',
            cancelenroll: url + '/yjypService/project-user-enroll/cancel-enroll/',
            chooseAllUserForProject: url + '/projectApply/train/choose-project/chooseAllUserForProject',
            updateChooseStatusBatch: url + '/projectApply/train/choose-project/updateChooseStatusBatch',
            chooseSearchExport: url + '/projectApply/train/choose-project/page-search-export',


        },
        district: {
            courseList: url + '/projectApply/course/period/list/current',
            joinedList: url + '/projectApply/course/period/list/joined',
            courseChooseUser: url + '/projectApply/course/page-list/',
            queryRecordInfo: url + '/projectApply/project-apply/queryRecordInfo',
            courseDetail: url + '/projectApply/course/detail',
            courseChooseUserChoose: url + '/projectApply/course/course-choose-user/choose',
            userChooseList: url + '/projectApply/course/course-choose-user/list-course',
            userCancel: url + '/projectApply/course/course-choose-user/cancel-choose',

        },
        qmpxService: {
            getTeacherInfo: url + '/qmpxService/api/assess/getTeacherInfo', //获取教师信息
            getAssess: url + '/qmpxService/api/assess/getAssess', //查看评价
        },
        listApply: {
            queryProjectList: url + '/projectApply/project/queryProjectList',
            ossPreview: url + '/projectApply/oss/preview-url?fileName=',
            queryCanApplyList: url + '/projectApply/project/queryCanApplyList', //学员个人中心-查询可申报项目列表
            applyList: url + '/projectApply/research-type/page-search', //事项类型列表查询
            listApply: url + '/projectApply/project-apply/listApply', //申报记录列表
            applyReview: url + '/projectApply/apply/project-apply-review/page-search', //记录列表
            queryProjectInfo: url + '/projectApply/project/queryProjectInfo', //查询项目详细信息-申报页面
            downloadurl: url + '/projectApply/oss/download-url?fileName=', //获取下载地址
            uploadurl: url + '/projectApply/oss/upload-url?fileName=', //获取上传地址
            applyProject: url + '/projectApply/project-apply/applyProject', //提交资料-申报页面
            applyProjectForStaging: url + '/projectApply/project-apply/applyProjectForStaging', //提交资料-申报页面
            queryMatchTeachRecordList: url + '/projectApply/project-apply/queryMatchTeachRecordList',
            queryRecordInfo: url + '/projectApply/project-apply/queryRecordInfo', //查看申报记录详细信息-申报记录页面 
            queryprojectInfo: url + '/projectApply/project/',
            revokeApply: url + '/projectApply/project-apply/revokeApply/', //撤回材料-申报记录页面 
            getProjectCertificate: url + '/yjypService/project-certificate/getProjectCertificate/', //获取项目设置
            viewCertificate: url + '/yjypService/project-certificate/viewCertificate/', //下载证书
            reviewapply: url + '/projectApply/apply/project-apply-review/page-search',
            reportannex: url + '/projectApply/service/report-annex/page-search',
            /** 教师-课题变更申请 */
            applySubjectChangeTemplate: url + '/projectApply/project-apply-change/downloadTemplate', // 课题变更申请模板
            applySubjectChange: url + '/projectApply/project-apply-change/applyChange', // 申请课题变更
            getApplySubjectChangeList: url + '/projectApply/project-apply-change/listApply', // 查询课题变更申请列表
            /** 校长-课题变更审核 */
            getApplySubjectChangeAuditList: url + '/projectApply/project-apply-change/listUnderReview', // 待审核
            applySubjectChangeAudit: url + '/projectApply/project-apply-change/school/review',
            getApplySubjectChangeAuditedList: url + '/projectApply/project-apply-change/listReview', // 已审核
            findCodeByTypeCode: url + '/baseData/basecode/findCodeByTypeCode?typeCode=', // 获取字典
            // https://api.test.gdteacher.com/baseData/basecode/findCodeByTypeCode?typeCode=political_status&appId=APPY042
        },
        myCertificate: {
            getmyCertificateList: url + '/yjypService/platform-certificate/page-search' // 我的证书-证书列表
        },
        myManage: {
            listApplyForDeptManager: url + '/projectApply/project-apply/listApplyForDeptManager',  // 我的科研-我管理的
            getApplyHistory: url + '/projectApply/apply/project-apply-review/page-search', //我的科研-我管理的-查看审批记录
            getDownloadUrl: url + '/projectApply/oss/download-url?fileName=', //我的科研-我管理的-审批-获取url
            getReviewDetailData: url + '/projectApply/project-apply/queryRecordInfo?', //我的科研-我管理的-审批-获取url
            setState: url + '/projectApply/project-apply/updateDistrictReview' //我的科研-我管理的-审批
        },
        order: {
            courseOrderData: url + '/yjypService/courseOrder/listMyOrders', // 我的订单-订单列表
            cancalOrder: url + '/yjypService/courseOrder/cancelOrder', // 我的订单-取消订单
            getOrderInfo: url + '/yjypService/courseOrder/getOrderInfo', // 我的订单-订单详情
        },
        system: {
            preViewUrl: "http://eezxyl.ttcn.cn/?furl="
        }
    }
};



// WEBPACK FOOTER //
// ./src/core/apis.js